import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';

import { ErrorCannotOrder } from 'app/components/error-cannot-order';
import { i18n } from 'app/i18n';
import { owlImageProps } from 'app/resources/images';
import { I18nUtils } from 'app/utils/i18n-utils';
import { selectShoppingCartOrThrow } from 'app/pages/order/redux/order-selector';
import { DataLayerErrorType } from 'app/data-layers/model/data-layer-error-type';

export const CannotOrderMorePage: FunctionComponent = () => {
    const shoppingCart = useSelector(selectShoppingCartOrThrow);
    const {
        wifiUnitInformation: { maximumNumberOfUnits },
    } = shoppingCart;

    return (
        <ErrorCannotOrder
            title={i18n.page.error.cannotOrderMore.title}
            subtitles={[
                I18nUtils.message(i18n.page.error.cannotOrderMore.subtitle, {
                    maxAmount: maximumNumberOfUnits,
                }),
            ]}
            image={owlImageProps}
            dataLayerErrorType={DataLayerErrorType.CANNOT_ORDER_MORE_ERROR}
        />
    );
};
